import { render, staticRenderFns } from "./AddNewBlock.modal.vue?vue&type=template&id=58be5e92&"
import script from "./AddNewBlock.modal.vue?vue&type=script&lang=js&"
export * from "./AddNewBlock.modal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewBlock.modal.vue?vue&type=style&index=0&id=58be5e92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports